import { render, staticRenderFns } from "./on-tag-clients.vue?vue&type=template&id=3b0b5d91"
import script from "./on-tag-clients.vue?vue&type=script&lang=js"
export * from "./on-tag-clients.vue?vue&type=script&lang=js"
import style0 from "./on-tag-clients.vue?vue&type=style&index=0&id=3b0b5d91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports